module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vimeo-container"
  }, [_c('iframe', {
    attrs: {
      "src": _vm.videoSrc,
      "frameborder": "0",
      "allow": "autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media",
      "allowfullscreen": "",
      "title": "Guide til opgaveoversigt designeren"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-aff3b038!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TaskOverviewSettings/TaskOverviewSettingsGuide.vue
// module id = 1723
// module chunks = 1